/* eslint-enable */
/* eslint-enable */

class AnimationGalleryArbitrary {

	constructor(args = { sectionsContainer: document }) {
		this.sectionsContainer = args.sectionsContainer;
		this.$moduleGalleryArbitrary = this.sectionsContainer.querySelectorAll('.gallery-arbitrary');
		
		if (!this.$moduleGalleryArbitrary.length)
			return;
		
		this.$moduleGalleryArbitraryElements = [];

		this.$moduleGalleryArbitrary.forEach(module => {
			this.$moduleGalleryArbitraryElements.push(module.querySelectorAll('.anima'));
		});

		this.init();
	}

	/* eslint-disable class-methods-use-this, no-unused-vars */
	init() {
		this.setAnimation();
	}

	setAnimation() {
		this.$moduleGalleryArbitrary.forEach((module, index) => {
			gsap.set(module, { opacity: 1 });
			gsap.set(this.$moduleGalleryArbitraryElements[index], { yPercent: 20, opacity: 0, onComplete: () => {
				this.initAnimate(index);
			} });
		});
	}

	initAnimate(index) {
		this.moduleGalleryArbitrary = gsap.timeline({
			defaults: { duration: 1.2, ease: 'power4.out' },
            scrollTrigger: {
                trigger: this.$moduleGalleryArbitrary[index],
				start: '-20% 50%'
			},
			onComplete: () => {
				gsap.set(this.$moduleGalleryArbitraryElements[index], { clearProps: true });
			}
        });
    
        this.moduleGalleryArbitrary.addLabel('step1');
        this.moduleGalleryArbitrary.to(this.$moduleGalleryArbitrary[index], { opacity: 1, duration: 1 }, 'step1');
		this.moduleGalleryArbitrary.to(this.$moduleGalleryArbitraryElements[index], { yPercent: 0, opacity: 1, stagger: 0.2 }, 'step1+=0.3');
	}
	/* eslint-enable class-methods-use-this, no-unused-vars */
}

export default AnimationGalleryArbitrary;
